import { Pipe, PipeTransform } from '@angular/core';

import { DatesService } from '../../services/dates.service';

@Pipe({
  name: 'dateForSpecificTimezone',
})
export class DateForSpecificTimezonePipe implements PipeTransform {
  constructor(private datesService: DatesService) {}

  transform(originalDate: string, timeZone: string): string {
    return this.datesService.getMomentFormattedDateForSpecificTimezone(originalDate, timeZone);
  }
}
